import React from 'react';
import { connect } from 'react-redux';
import Pdf from '../pdfjs/Pdf';
import AttachmentDownload from '../attachmentDownload/AttachmentDownload.jsx';

const DocumentContent = ({ document: { loading, error, data, metadata: { type, fileName } } }) => {
  let content;
  if (data) {
    if (type === 'PICTURE') {
      content = <div className="content"><img alt="" src={data}/></div>;
    } else if (type === 'VIDEO') {
      content = (
        <iframe
          allowFullScreen={true}
          className="content content-video"
          src={data}
        />
      );
    } else if (type === 'PDF') {
      content = (
        <Pdf className="content content-pdf" src={data}/>
      );
    } else if (type === 'XLSX' || type === 'PPTX' || type === 'DOCX') {
      content = (
        <AttachmentDownload className="content" src={data} fileName={fileName}/>
      );
    } else {
      content = <iframe className="content" src={data}/>;
    }
  }

  return (
    <div className="doc-content">
      {loading && (
        <div className="content" id="wrapper">
          <div className="docu">
            Chargement en cours...
          </div>
        </div>
      )}
      {error && (
        <div className="content" id="wrapper">
          <div className="docu">
            Erreur lors du chargement du document...
          </div>
        </div>
      )}
      {!loading && !error && data && content}
    </div>
  );
};

const selector = state => ({
  document: state.document,
});

export default connect(selector)(DocumentContent);



// WEBPACK FOOTER //
// ./book/src/document/DocumentContent.jsx